import React from "react";
import { H1, H2, H3, H4, H5, H6, P } from "orcs-design-system";
import PropTypes from "prop-types";

import AICharts from "../../AIContent/common-components/AICharts";
import CanvBarChart from "../AIDashboardComponents/CanvBarChart";
import CanvGroupTypesSelect from "../AIDashboardComponents/CanvGroupTypesSelect";
import CanvLineChart from "../AIDashboardComponents/CanvLineChart";
import CanvOrgChart from "../AIDashboardComponents/CanvOrgChart";
import CanvSelectTeamId from "../AIDashboardComponents/CanvSelectTeamId";
import CanvTeamDescription from "../AIDashboardComponents/CanvTeamDescription";
import CanvTeamDetails from "../AIDashboardComponents/CanvTeamDetails";
import CanvTeamForecastChart from "../AIDashboardComponents/CanvTeamForecastChart";
import CanvTeamMembers from "../AIDashboardComponents/CanvTeamMembers";
import CanvTeamObjectives from "../AIDashboardComponents/CanvTeamObjectives";
import CanvTeamSearch from "../AIDashboardComponents/CanvTeamSearch";
import CanvTeamTable from "../AIDashboardComponents/CanvTeamTable";

const EChartWrapper = ({ config, ...rest }) => {
  let specs = [];
  let parsedConfig = null;

  if (config) {
    try {
      parsedConfig = typeof config === "string" ? JSON.parse(config) : config;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error parsing EChart config", e);
      return <P>Error parsing EChart config</P>;
    }
  }

  if (parsedConfig) {
    specs = Array.isArray(parsedConfig) ? parsedConfig : [parsedConfig];
  }

  return <AICharts specs={specs} {...rest} />;
};

EChartWrapper.propTypes = {
  config: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

EChartWrapper.defaultProps = {
  config: null,
};

export const jsonComponentRegistry = {
  dashboard: "div",
  div: "div",
  span: "span",
  p: P,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  strong: "strong",
  em: "em",
  i: "i",
  b: "b",
  ul: "ul",
  ol: "ol",
  li: "li",
  a: "a",
  table: "table",
  thead: "thead",
  tbody: "tbody",
  tr: "tr",
  th: "th",
  td: "td",
  br: "br",
  hr: "hr",
  code: "code",
  pre: "pre",
  blockquote: "blockquote",

  "team-search-input": CanvTeamSearch,
  "selected-team-id": CanvSelectTeamId,
  "team-table-input": CanvTeamTable,
  "team-details-output": CanvTeamDetails,
  "team-description-output": CanvTeamDescription,
  "team-objectives-output": CanvTeamObjectives,
  "team-members-output": CanvTeamMembers,
  "org-chart-output": CanvOrgChart,
  "bar-chart-output": CanvBarChart,
  "line-chart-output": CanvLineChart,
  "team-types-select-input": CanvGroupTypesSelect,
  "team-forecast-chart-output": CanvTeamForecastChart,

  "e-chart": EChartWrapper,
  graph: EChartWrapper,
};

export { EChartWrapper };
